enum LoadedState {
  initial = 0,
  loading,
  finished,
  failed,
  blocked,
}

export default LoadedState;
